import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const rawUser = localStorage.getItem('user');
    const user = rawUser ? JSON.parse(rawUser) : null;
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate('/login');
        }
    }, [token, navigate]);

    if (!token) return null;
    if (user?.role !== 'admin') {
        return <Navigate to="/accident-filing" replace />;
    }
    return children;
};

export default AdminRoute;
